import {
  ACTION_LOAD_CAMPAIGN_NAMES__REQUEST,
  ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS,
  ACTION_LOAD_CAMPAIGN_NAMES__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CAMPAIGN_NAMES__REQUEST:
    case ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS:
      return null;

    case ACTION_LOAD_CAMPAIGN_NAMES__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
